/**
 * Statusse der Änderungen an Kundendaten
 *  */ 
export enum iomBookingState {
    applying = "IOM beantragend",
    confirmed = "IOM aktiv",
    cancelling = "IOM kündingend",
    noState = ""
}